"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const addContactPerson = (0, graphql_tag_1.default)`
  mutation users_contactPersons_addContactPerson($comment: CommentInput, $data: ContactPersonInputSchema!) {
    users {
      contactPersons {
        addContactPerson(comment: $comment, data: $data) {
          status
          node {
            id
            firstName
            lastName
            middleName
            avatarUrl
            email
            phone
            isMain
            userId
            allowNotify
            allowNotifySendDate
          }
        }
      }
    }
  }
`;
exports.default = addContactPerson;